import React from 'react';
import { GridTable } from '@components/common/grid';
import { formatWithDefault, formatCurrency } from '@common/utils';

const GridTableAnnuityBegin = ({
  id = 'grid-policy-change-annuity',
  title,
  data,
  isCurrencyUsd,
  isNotLongTermPrfdBonus,
}) => (
  <GridTable
    id={id}
    title={title}
    sideTitle={isCurrencyUsd ? '(단위: 달러)' : '(단위: 원)'}
    options={{
      data,
      colNames: ['만기보험금액'].concat(
        isCurrencyUsd || isNotLongTermPrfdBonus
          ? []
          : ['장기유지보너스 발생후 적립액'],
      ),
      colModel: [
        {
          name: 'shtnAnutyBgnExpirBnf',
          index: 'shtnAnutyBgnExpirBnf',
          formatter: formatWithDefault(value =>
            formatCurrency(value, isCurrencyUsd),
          ),
        },
      ].concat(
        isCurrencyUsd || isNotLongTermPrfdBonus
          ? []
          : [
              {
                name: 't1longTermPrfdBonus',
                index: 't1longTermPrfdBonus',
                formatter: formatWithDefault(value =>
                  formatCurrency(value, isCurrencyUsd),
                ),
              },
            ],
      ),
    }}
  />
);

export default GridTableAnnuityBegin;
